/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { WVCall } from '../../../bridges/windvane/index.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';

function clearNaviBarRightItem(params) {
    // 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
    var formatInput = function () { return ({
        buttonText: null,
        showButton: false,
        imagePosition: 'right',
    }); };
    WVCall('CNHybridNavigationBar.setRightBarButton', params, { formatInput: formatInput });
}

export { clearNaviBarRightItem as default };
